import React from "react"
import { Wrapper, Text } from "./styles"
import { Icon } from "components/Icons"

const ScrollTopButton = ({color}) => {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" })
  }
  return (
    <Wrapper color={color} onClick={handleClick}>
      <Text color={color}>Powrót do góry</Text>
      <Icon type={"scrollTop"} color={color} />
    </Wrapper>
  )
}

export { ScrollTopButton }
